// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"856":"04fad3a1","881":"deedcdf8"}[chunkId] + ".js";
};